import React, { useContext } from 'react';

import {
  SyncIntegrationNames,
  SyncReviewIntegrationNames,
} from 'common/constants/autopilotIntegrations';
import { type Company, CompanyContext } from 'common/containers/CompanyContainer';

import type { Integration } from 'common/constants/billing';

export type ActiveIntegrations = {
  activeIntegrations: Record<Integration, boolean>;
  integrationCount: number;
  integrationLimit: number | null;
};
export const ActiveIntegrationContext = React.createContext<ActiveIntegrations>({} as any);

const ReviewIntegrationNames = Object.values(SyncReviewIntegrationNames);
const FreeIntegrations = new Set([
  'googleAnalytics',
  ...ReviewIntegrationNames,
  SyncIntegrationNames.gong,
  SyncIntegrationNames.zoom,
  SyncIntegrationNames.helpscout,
  SyncIntegrationNames.tldv,
  SyncIntegrationNames.freshdesk,
]);

const generateIntegrationObject = (company: Company) => {
  const { activeIntegrations } = company;
  return {
    ...activeIntegrations,
    googleAnalytics: !!company.gaPropertyID,
  };
};

type Props = {
  company: Company;
  children: React.ReactNode;
};

const ActiveIntegrationContainer = ({ children }: Props) => {
  const company = useContext(CompanyContext);
  const activeIntegrations = generateIntegrationObject(company);
  const integrationCount = Object.keys(activeIntegrations)
    .filter((key) => !FreeIntegrations.has(key))
    .map((key) =>
      key in activeIntegrations ? activeIntegrations[key as keyof typeof activeIntegrations] : null
    )
    .reduce((acc, curr) => (curr ? acc + 1 : acc), 0);
  const integrationLimit = company.limits?.integrations;

  return (
    <ActiveIntegrationContext.Provider
      value={{ activeIntegrations, integrationCount, integrationLimit }}>
      {children}
    </ActiveIntegrationContext.Provider>
  );
};

export default ActiveIntegrationContainer;
